import { create } from 'zustand';

export interface AccessOverrideInfo {
    overrideEmployeeId?: string;
    overrideEmployeeName?: string;
}

export interface AccessRequiredProps {
    permission: string;
    onConfirm: (overrideInfo?: AccessOverrideInfo) => void;
}

interface AccessRequiredStore {
    props?: AccessRequiredProps;
    showAuthModal: (props: AccessRequiredProps) => void;
    hideAuthModal: VoidFunction;
}

export const useAccessRequiredStore = create<AccessRequiredStore>((set) => ({
    props: undefined,
    hideAuthModal: () => {
        set({ props: undefined });
    },
    showAuthModal: (props) => {
        set({ props });
    },
}));
